<template>
  <div v-if='response' v-html='response'></div>
</template>

<script>
  export default {
    props: ['url'],
    data() {
      return {
        response: null,
      }
    },
    created: async function() {
      const response = await fetch(this.url, {credentials: 'include'})
      this.response = await response.text()
    },
  }
</script>



// WEBPACK FOOTER //
// sportspower/assets/es6/components/FetchHtml.vue